'use client';

import { memo } from 'react';
import { useTranslations } from 'next-intl';
import { buildRoute, DataTestConfig } from '@headless-workspace/config';
import { GlowClickable, GlowIcon, Icons, PropsWithLocale } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

type LogoProps = PropsWithLocale & { isH1Logo: boolean };

export const Logo: ComponentMemo<LogoProps> = memo(({ isH1Logo, locale }) => {
    const t = useTranslations('Header.companyLogo');

    const logo = () => {
        return (
            <GlowClickable
                ariaLabel={t('ariaLabel.alt')}
                href={buildRoute(locale, 'home')}
                content={{
                    icon: (
                        <GlowIcon
                            Icon={Icons.LogoSephora}
                            type={'fullSize'}
                            alt={t('ariaLabel.alt')}
                            className={
                                'min-w-sephoraLogoSmall w-sephoraLogoSmall desktopS:w-sephoraLogo desktopS:min-w-sephoraLogo text-text-primary'
                            }
                        />
                    ),
                }}
                dataTestId={DataTestConfig.testIds.backToHomepageLink}
            />
        );
    };

    return isH1Logo ? <h1>{logo()}</h1> : logo();
});

Logo.displayName = 'Logo';
